import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';
import { ProviderTypeIcon } from '../provider-type-icon/provider-type-icon';

@Component({
  selector: 'cmi-property-group-item',
  imports: [ProviderTypeIcon, TranslatePipe],
  templateUrl: './property-group-item.html'
})
export class PropertyGroupItem {
  public readonly groupName = input.required<string>();
  public readonly providerType = input.required<string>();
  public readonly isDraggable = input<boolean>(false);
  public readonly isDeleting = input.required<boolean>();
  public readonly isFirst = input<boolean>(false);
  public readonly isLast = input<boolean>(false);
  public readonly isDragging = input<boolean>(false);
  public readonly isDragOver = input<boolean>(false);
  public readonly dragOverPosition = input<'before' | 'after'>('before');

  public readonly moveUp = output<void>();
  public readonly moveDown = output<void>();
  public readonly edit = output<void>();
  public readonly confirmDelete = output<void>();
  public readonly cancelDelete = output<void>();
  public readonly delete = output<void>();
  public readonly dragStarted = output<DragEvent>();
  public readonly dragOvered = output<DragEvent>();
  public readonly dropped = output<DragEvent>();
  public readonly dragEnded = output<void>();
}
